export default class {
    /**
     * This only works the pub/assets/js/App/Entities/Mix.es6
     * The abstract base model Supports the following features:
     * - Observer pattern
     * - Creation from plain json objects
     * @todo: Merge logic with pub/assets/js/App/Entities/Mix.es6
     */
    /**
     * Initializes a new Base model.
     *
     * @param propertyDefinitions The properties to declare with the default values.
     * @param plainObject The plain json.
     */
    constructor (propertyDefinitions = {}, plainObject = {}) {
        const properties = $.map(propertyDefinitions, function(_, key) { return key; });
        this._observers = [];
        this._initializeProperties(properties);
        this._initializeDefaults(propertyDefinitions);
        this._fromPlainObject(plainObject);
    }

    /**
     * Initializes the class properties.
     *
     * @param properties A list of properties to be defined.
     * @private
     */
    _initializeProperties (properties) {
        const self = this;
        $.each(properties, function (_, property) {
            self.___ = {};
            Object.defineProperty(self, property, {
                get: function () {
                    return self.___[property];
                },
                set: function (value) {
                    if ($.isArray(value)) {
                        value = value.slice(0);
                    } else if ($.isPlainObject(value)) {
                        value = $.extend(true, {}, value);
                    }
                    self.___[property] = value;
                }
            });
        });
    }

    /**
     * Initialize the model from the plain json object.
     *
     * @param plainObject The plain json object.
     */
    _fromPlainObject (plainObject) {
        const self = this;

        /* Initialize the entity from the plain object. */
        $.each(plainObject, function (propertyName, propertyValue) {
            self[propertyName] = propertyValue;
        });
    }

    /**
     * Initializes the default values for defined class properties.
     *
     * @param values object The values.
     *
     * @protected
     */
    _initializeDefaults (values = {}) {
        const self = this;
        $.each(values, function (property, value) {
            self[property] = value;
        });
    }

    /**
     * Register an observer.
     *
     * @param observer object The object that's updated when the model changes.
     * @return mymuesli.entities.AbstractBase The object itself for chaining.
     */
    registerObserver (observer) {
        if (this._observers.indexOf(observer) === -1) {
            this._observers.push(observer);
        }
        return this;
    }

    /**
     * Remove an observer.
     *
     * @param observer object The object that should be removed as observer.
     * @return mymuesli.entities.AbstractBase The object itself for chaining.
     */
    removeObserver (observer) {
        const index = this._observers.indexOf(observer);
        this._observers.splice(index, 1);
        return this;
    }

    /**
     * Notifies all registered observers that the model has been changed.
     *
     * @return Mix The object itself for chaining.
     */
    notify () {
        const self = this;
        $.each(this._observers, function (_, observer) {
            observer.update(self);
        });
        return this;
    }

    /**
     * Returns the plain object representation of the current instance.
     *
     * @return {*} The current instance as plain object.
     */
    toPlainObject () {
        const result = {};
        $.each(this.___, function (key, value) {
            if (value instanceof AbstractBase) {
                value = value.toPlainObject();
            }
            result[key] = value;
        });
        return result;
    }

    /**
     * Checks if a property is set. eg. if (mix.has('image')) { }.
     *
     * @param property The property that should be set, that means not be null.
     * @return boolean
     */
    has (property) {
        return (this.___[property] !== null);
    }
}
